import { render, staticRenderFns } from "./TBXCodeDialog.vue?vue&type=template&id=2c543948&scoped=true"
import script from "./TBXCodeDialog.vue?vue&type=script&lang=js"
export * from "./TBXCodeDialog.vue?vue&type=script&lang=js"
import style0 from "./TBXCodeDialog.vue?vue&type=style&index=0&id=2c543948&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c543948",
  null
  
)

export default component.exports